import modular from 'modujs';

import globals from './globals';
import * as modules from './modules';

import { html } from './utils/environment';
import debounce from './utils/debounce';

import { gsap } from './gsap';
import focusVisible from 'focus-visible';

const app = new modular({
    modules: modules
});

window.onload = (event) => {

    const setHtmlHeight = () => {
        html.style.setProperty('--vh', `${window.innerHeight/100}px`)
    }

    // Set html initial vh
    setHtmlHeight()

    // Add resizeEnd event to window
    const resizeEndEvent = new CustomEvent('resizeEnd');
    window.addEventListener('resize', debounce(() => {
        setHtmlHeight()
        window.dispatchEvent(resizeEndEvent)
    }, 200, false))


    // Watch body height change
    let timeout
    const bodyResizeEvent = new CustomEvent('bodyResize');
    new ResizeObserver(() => {

        if(timeout) {
            clearTimeout(timeout)
        }

        timeout = setTimeout(() => {
            window.dispatchEvent(bodyResizeEvent)
        }, 200)
    }).observe(document.body)


    const loader = new Promise(resolve => {

        const $logo = document.getElementById('loader-logo')
        const $logoLetters = $logo.querySelectorAll('svg > *')

        const tl = gsap.timeline({
            onComplete: () => {
                resolve()
                $logo.remove()
            }
        })

        tl
            .set($logo, {
                opacity: 1
            })
            .fromTo($logo,
                {
                    yPercent: -100,
                },
                {
                    yPercent: 0,
                    duration: 1,
                    ease: 'power2.out',
                },
            )
            .from($logoLetters, {
                yPercent: -110,
                duration: .7,
                ease: 'power2.out',
                stagger: {
                    amount: .3,
                },
            }, '<')
            .to($logo, {
                yPercent: 20,
                duration: 1,
                ease: 'power2.in',
                delay: .2
            })
            .to($logoLetters, {
                yPercent: 110,
                duration: .7,
                ease: 'power2.in',
                stagger: {
                    amount: .3
                },
            }, '<')
    })


    // Preload content before
    const domLoad = id => {
        return new Promise((resolve, reject) => {
            const $el = document.getElementById(id)
            if ($el === null || $el.isLoaded) {
                resolve();
            } else {
                const loadEvent = 'load'
                $el.addEventListener('loadEvent', () => {
                    resolve()
                });
            }
        })
    }


    Promise.all([loader, domLoad('main-css')]).then(init)
};

function init() {
    globals();

    app.init(app);

    html.classList.add('is-loaded');
    html.classList.add('is-ready');
    html.classList.remove('is-loading');
    html.classList.remove('-firstload');
}

